

                    <div class="tab-pane" role="tabpanel" id="archivos">


                        <fieldset id="archivos" class="archivos row">

                            <div *ngIf="!yasubieron" class="row">
                                <div align="center" class="col-md-12"
                                    style="font-size: 30px; padding-bottom: 30px; padding-top: 30px">
                                    <h4>
                                        Archivos a adjuntar <span>(MAXIMO 2 ARCHIVOS)</span>
                                    </h4>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12" align="center" style="padding-bottom: 20px">

                                    <p style="font-size: 14px">Tiene un máximo de <strong>75 MB</strong>, Al subir los
                                        archivos adjuntos, favor presione el boton:</p>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-md-12" align="center" style="padding-bottom: 20px">
                                    <button *ngIf="!yasubieron" mat-raised-button
                                        [@bounce]="{ value: animate, params: { duration: 1500 }}"
                                        style="background-color: darkorange" (click)="confirmarSubida();"
                                        [disabled]="!(files.length>0) || yasubieron">Subir archivos</button>
                                    <h3 *ngIf="yasubieron">Archivos ya fueron subidos</h3>
                                </div>
                            </div>

                            <div class="col-md-12" align="center" id="content" *ngIf="acotado">
                                <div class="form-group" style="padding-top: 20px;margin-bottom: 2rem;" align="center">
                                    <div class="row">
                                        <div class="col-md-4"></div>
                                        <div class="col-md-4" align="center">
                                            <button *ngIf="!yasubieron" mat-raised-button color="primary"
                                                style="padding-top: 5px;margin-bottom: 2rem;" id="ingreso_documentos"
                                                (click)="openAdjuntosModal(); nombreArchivo = ''; documentoNombre = ''; ">
                                                Agregar Documentación
                                                <mat-icon aria-label="icon">add_circle_outline</mat-icon>
                                            </button>
                                        </div>
                                        <div class="col-md-4"></div>
                                    </div>
                                </div>
                                <div class="datatable_adjuntos">


                                    <ngx-datatable class="material expandable" [messages]="''" [rows]="rows"
                                        [columnMode]="'force'" [headerHeight]="'auto'" [footerHeight]="'auto'"
                                        [rowHeight]="'auto'" style="width: 100%; text-align: left;">
                                        <ngx-datatable-column>
                                            <ng-template ngx-datatable-header-template>
                                                <span>NOMBRE DOCUMENTO</span>
                                            </ng-template>
                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                {{row.name}}
                                            </ng-template>
                                        </ngx-datatable-column>
                                        <ngx-datatable-column>
                                            <ng-template ngx-datatable-header-template>
                                                <span>NOMBRE DE ARCHIVO</span>
                                            </ng-template>
                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                {{row.archivo}}
                                            </ng-template>
                                        </ngx-datatable-column>

                                        <ngx-datatable-column>
                                            <ng-template ngx-datatable-header-template>
                                                <span>PESO</span>
                                            </ng-template>
                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                {{(row.peso + '').replace('.',',')}}
                                            </ng-template>
                                        </ngx-datatable-column>

                                        <ngx-datatable-column>
                                            <ng-template ngx-datatable-header-template>
                                                <span>OPCIONES</span>
                                            </ng-template>
                                            <ng-template let-row="row" let-rowIndex="rowIndex"
                                                ngx-datatable-cell-template>

                                                <span *ngIf="!yasubieron" (click)="deleteFile(rowIndex)"><i
                                                        class="glyphicon glyphicon-trash"></i></span>
                                            </ng-template>
                                        </ngx-datatable-column>

                                        <ngx-datatable-column>
                                            <ng-template ngx-datatable-header-template>
                                                <span>ESTADO</span>
                                            </ng-template>
                                            <ng-template let-row="row" ngx-datatable-cell-template>
                                                <label style="color:green" *ngIf="row.estado=='Subido'">
                                                    {{row.estado}}
                                                </label>
                                                <label style="color:red" *ngIf="row.estado!='Subido'">
                                                    {{row.estado}}
                                                </label>
                                            </ng-template>
                                        </ngx-datatable-column>




                                    </ngx-datatable>



                                    <div class="row">
                                        <div class="col-lg-6 col-md-6 col-sm-6" align="left">
                                            <button mat-raised-button color="primary" matStepperPrevious>Volver</button>
                                        </div>
                                        <div class="col-lg-6 col-md-6 col-sm-6" align="right">
                                            <!-- [disabled]="zip === null || zip === undefined|| zip.length===0 " -->
                                            <button [disabled]="!yasubieron"  mat-raised-button color="primary"
                                               
                                                matStepperNext>Continuar</button>
                                        </div>
                                    </div>


                                </div>
                            </div>
                        </fieldset>

                        <ng-template #openModal>
                            <h2 mat-dialog-title align="center">Recordatorio</h2>
                            <mat-dialog-content>
                                <div align="center">
                                    Por favor en el punto <strong>ANTECEDENTES QUE SE ADJUNTAN</strong>, marcar
                                    documentos que se van a adjuntar, para que estos se reflejen en el formulario a
                                    imprimir. Recuerda adjuntar el formulario firmado y escaneado
                                    en el siguiente paso.
                                </div>
                            </mat-dialog-content>
                            <mat-dialog-actions align="center">
                                <button mat-raised-button color="primary" id="cerrarModal"
                                    (click)="cerrarModal() ">Cerrar <i class="alert-circle "
                                        aria-hidden="true "></i></button>
                            </mat-dialog-actions>
                        </ng-template>

                        <ng-template #modalArchivos>
                            <h2 mat-dialog-title align="center">Alerta</h2>
                            <mat-dialog-content>
                                <div align="center">
                                    Adjuntar Documentos
                                </div>
                            </mat-dialog-content>
                            <mat-dialog-actions align="center">
                                <button mat-raised-button color="primary" id="cerrarModal"
                                    (click)="cerrarModal() ">Cerrar <i class="alert-circle "
                                        aria-hidden="true "></i></button>
                            </mat-dialog-actions>
                        </ng-template>











                        <ng-template #modalAdjuntos>
                            <h2 mat-dialog-title align="center">Agregar Documento </h2>
                            <!-- <h2 *ngIf="nombreMuni=='Lo Barnechea'" mat-dialog-title align="center">Agregar Documento (pdf)</h2> -->
                            <mat-dialog-content>
                                <div align="center">

                                    <p *ngIf="docRepetido">nombre ya existe, intente con otro</p>
                                    <mat-form-field class="col-md-12">
                                        <mat-label>Nombre del Documento</mat-label>


                                        <input type="text" matInput [(ngModel)]="documentoNombre"
                                            (change)="enableUpload=true;">
                                        <!--solo si no son iguales a algun -->

                                    </mat-form-field>
                                    <!-- <p *ngIf="fileRepetido">este archivo ya fue adjunto, intente con otro</p> -->
                                    <mat-form-field
                                        matTooltip="{{!documentoNombre?'Agregue el nombre del documento primero':null}}"
                                        class="col-md-12" style="cursor: pointer;">

                                        <input type="text" matInput (click)=" file.click()"
                                            [disabled]="!documentoNombre || !enableUpload" [value]="nombreArchivo"
                                            style="cursor: pointer;" onpaste="return false;" onCopy="return false"
                                            onCut="return false" onDrag="return false" onDrop="return false"
                                            autocomplete=off>

                                        <mat-icon matSuffix color="primary" (click)="file.click(); "
                                            *ngIf="documentoNombre">attach_file
                                        </mat-icon>
                                        <mat-icon matSuffix [ngStyle]="{'color':'grey'}" *ngIf="!documentoNombre">
                                            attach_file</mat-icon>
                                        <!-- <mat-icon matSuffix color="secondary" *ngIf="!documentoNombre" >attach_file</mat-icon> -->


                                    </mat-form-field>


                                </div> <input type="file" #file (change)="handleFileInput($event.target.files)"
                                    style="display:none;" [accept]="docAccept">
                            </mat-dialog-content>
                            <mat-dialog-actions align="center">
                                <button mat-raised-button color="primary" id="cerrarModal"
                                    (click)="documentoNombre = ''; nombreDeDocumento = ''; nombreArchivo = ''; docRepetido = false; fileRepetido = false; cerrarModal();  enableUpload=false; ">Cancelar
                                    <i class="alert-circle " aria-hidden="true "></i></button>

                                <button mat-raised-button color="primary" id="addName"
                                    (click)="validarSubida(); enableUpload = false; "
                                    [disabled]="!documentoNombre || !nombreArchivo ">Adjuntar</button>
                            </mat-dialog-actions>
                        </ng-template>

                    </div>
                    <div class="separator">

                    </div>


                    <ng-template #confirmaSubida *ngIf="!yasubieron">
                        <h2 mat-dialog-title align="center">Adjuntar Documentos</h2>
                        <mat-dialog-content>
                            <div align="center">
                                Está seguro de subir los archivos? una vez subidos ya no podrá editarlos.

                            </div>
                        </mat-dialog-content>
                        <mat-dialog-actions align="center">
                            <button mat-raised-button color="warn" id="cerrarModal" (click)="cerrarModal() ">Cancelar<i
                                    class="alert-circle " aria-hidden="true "></i></button>
                            <button mat-raised-button color="primary" id="addName" (click)="uploadAllfiles();"
                                [disabled]="yasubieron">Aceptar</button>

                        </mat-dialog-actions>
                    </ng-template>


